import { useUi } from "../state/ui";

const SHORTCUTS: Array<[string, string]> = [
  ["c", "Criar evento"],
  ["t", "Ir para hoje"],
  ["d / w / m / y / a / x", "Dia / Semana / Mês / Ano / Programação / 4 dias"],
  ["j ou n", "Próximo período"],
  ["k ou p", "Período anterior"],
  ["/", "Pesquisar"],
  ["e", "Editar o evento aberto"],
  ["Delete", "Excluir o evento aberto"],
  ["s", "Configurações"],
  ["Esc", "Fechar"],
  ["?", "Mostrar atalhos"]
];

export function ShortcutsHelp() {
  const ui = useUi();
  return (
    <div className="scrim" onPointerDown={(e) => e.target === e.currentTarget && ui.setOverlay(null)}>
      <div className="dialog" role="dialog" aria-label="Atalhos de teclado" style={{ width: 460 }}>
        <h2>Atalhos de teclado</h2>
        <table style={{ width: "100%", borderCollapse: "collapse" }}>
          <tbody>
            {SHORTCUTS.map(([k, label]) => (
              <tr key={k}>
                <td style={{ padding: "6px 0", color: "var(--text-2)" }}>{label}</td>
                <td style={{ textAlign: "right" }}>
                  <kbd style={{ background: "var(--bg-input)", borderRadius: 4, padding: "2px 8px", fontFamily: "inherit" }}>{k}</kbd>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        <div className="actions">
          <button className="btn primary" onClick={() => ui.setOverlay(null)}>
            Fechar
          </button>
        </div>
      </div>
    </div>
  );
}
